import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss']
})
export class BadgeComponent {
  @Input() cls: string;
  @Input() icon: string;
  @Input() label: string;
  @Input() compact = false;

  get tooltip(): string {
    return this.compact ? this.label : null;
  }
}
